<app-app-download title="Advantage4dealers App"
                  icon="fa-mobile-screen"
                  subtitle="The electronic order form for phone and tablet"
                  description="Take orders, collect payments and register customers from any phone or tablet. The Advantage4dealers app is your electronic order form for the field and needs an internet connection to work."
                  [iosDownloadUri]="iosAppUri"
                  [androidDownloadUri]="androidAppUri"
                  [androidInstructionsUri]="androidAppDownloadInstructionsUri"
                  [iosInstructionsUri]="iOSAppDownloadInstructionsUri"
                  [supportUri]="supportUri">

   <li>Take a product order electronically, with product lists customized to your dealer organization.</li>
   <li>Offer customizable pricing plans and capture the customer's signature on the spot.</li>
   <li>Take cash, check and credit card payments. Checks are processed by EFT and cards are processed in real time.</li>
   <li>
      <a href="https://southwesternlead.com" target="_blank" rel="noopener">LEAD</a>,
      <a href="http://advantage4kids.com/" target="_blank" rel="noopener">Advantage4Kids</a>,
      <a href="https://skwids.com/" target="_blank" rel="noopener">SkWids</a> and
      <a href="https://advantage4teens.com/" target="_blank" rel="noopener">Advantage4Teens</a>
      registration is built into the order flow.
   </li>

</app-app-download>
